import React from 'react'
import { useTheme } from '@/components/ThemeProvider'
import { PolicyAddress } from '@/components/policyAddress'
import { getRegionUrl } from '@/helpers/getCountryCode'

const AppStoreRatingBrand = () => {
  const { theme } = useTheme()
  const region = localStorage.getItem('region') || 'US'
  const privacyPolicyRoute = getRegionUrl(region, 'privacy-policy')
  const termsRoute = getRegionUrl(region, 'terms-of-use')

  return (
    <section className="pb-10 relative ">
      <div className="relative flex flex-col gap-2 grow justify-center items-center text-center">
        <h2 className="uppercase font-[700] text-darkGrayText dark:text-grayText text-base">
          Cleaned over
        </h2>
        <p className="text-XL font-semibold">50+ Million Photos</p>
      </div>
      <div className="p-4 mt-8 flex flex-col items-center gap-4 rounded-4xl dark:bg-transparent bg-[#A9B2FF] dark:bg-grayGradient mx-auto">
        <p className="flex flex-row items-center text-M leading-4 font-bold tracking-[0.5px] gap-1.5">
          <svg width="101" height="24">
            <use href="/svg/sprite.svg#apple-new"></use>
          </svg>
        </p>
        <p className="flex flex-row gap-3 text-LXL2 font-semibold items-center dark:text-[#FBFBFB] text-[#070D7A]">
          <span>4.7</span>
          <img
            src={`${theme === 'light' ? '/img/rating/light/stars-new.svg' : '/img/rating/stars-new.svg'}`}
            alt="App Store Clean Master Rating"
            className="max-w-[128px] h-6"
          />
        </p>
        <p className="text-center text-base dark:text-lightText font-medium text-[#070D7A]">
          36.9K Ratings
        </p>
      </div>
      <PolicyAddress />
      <p className="relative z-20 mt-3 text-center text-[#7f7f7f] text-[11px]">
        © 2025{' '}
        <a href="https://clean-master.app" className="underline">
          Clean-master.app
        </a>{' '}
        |{' '}
        <a href={termsRoute} className="underline">
          Terms & Conditions
        </a>{' '}
        |{' '}
        <a href={privacyPolicyRoute} className="underline">
          Privacy Policy
        </a>
      </p>
      <p className="relative z-20 mt-3 text-center text-[#7f7f7f] text-[11px]">
        If you have any questions, complaints, or suggestions, please contact us at{' '}
        <a href="mailto:support@clean-master.app" className="underline">
          support@clean-master.app
        </a>
        .
      </p>
    </section>
  )
}

export default AppStoreRatingBrand
